<template>
  <q-btn
    class="supplier-repeatable-action"
    data-testid="supplier-repeatable-action"
    outline
    type="button"
    :aria-label="resolvedAriaLabel"
    :disable="disabled"
    @click="handleClick"
  >
    <q-icon
      class="supplier-repeatable-action__icon"
      data-testid="supplier-repeatable-action-icon"
      :name="icon"
    />
  </q-btn>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import './RepeatableSectionAction.css';

const props = withDefaults(
  defineProps<{
    icon?: string;
    ariaLabel?: string;
    disabled?: boolean;
  }>(),
  {
    icon: 'add',
    ariaLabel: undefined,
    disabled: false,
  },
);

const emit = defineEmits<{
  (event: 'click', value: MouseEvent): void;
}>();

const resolvedAriaLabel = computed(() => {
  if (props.ariaLabel) return props.ariaLabel;
  return props.icon === 'remove' ? 'Remove row' : 'Add row';
});

function handleClick(event: MouseEvent) {
  if (props.disabled) return;
  emit('click', event);
}
</script>
